export default {
    title: 'Section 1',
    icon: 'LayersIcon',
    route: 'catalogue-section1',
    tag: 0,
  }
  